import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
    MatDialog,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle,
} from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ErrorDialogComponent } from '../../../shared/dialogs/error-dialog/error-dialog.component';
import { SalesService } from '../../../shared/services/sales.service';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-sale-entry-dialog',
    standalone: true,
    imports: [CommonModule, MatDialogTitle, MatDialogContent, MatDialogActions, MatButtonModule, MatDialogClose, ReactiveFormsModule],
    templateUrl: './sale-entry-dialog.component.html',
    styleUrl: './sale-entry-dialog.component.scss',
})
export class SaleEntryDialogComponent {
    public readonly entry = new FormControl<string>('', Validators.required);

    public loading = false;

    public valid: boolean | undefined;

    public constructor(
        private readonly sales: SalesService,
        private readonly router: Router,
        private readonly dialogRef: MatDialogRef<SaleEntryDialogComponent>,
        private readonly dialog: MatDialog,
    ) {
        //
    }

    public onSaleEntry(): void {
        const saleCode = this.entry.value;
        if (!saleCode) {
            return;
        }

        this.loading = true;
        this.sales.validate(saleCode).subscribe((result) => {
            if (!result) {
                this.dialog.open(ErrorDialogComponent, {
                    data: 'The code entered is invalid. Please check for typos and try again.',
                    width: '500px',
                });

                this.loading = false;
                this.valid = false;
                return;
            }

            this.valid = true;
            this.router.navigate([`/sale/${saleCode}`]);
            this.dialogRef.close();
        });
    }
}
